module.exports = __webpack_public_path__ + "img/box2_img.add43630.png";